export const DashboardConfigConstants = {
  GET_CHART_QUERY_CONFIGS_REQUEST: 'CHART/GET_CHART_QUERY_CONFIGS_REQUEST',
  GET_CHART_QUERY_CONFIGS_SUCCESS: 'CHART/GET_CHART_QUERY_CONFIGS_SUCCESS',
  GET_CHART_QUERY_CONFIGS_ERROR: 'CHART/GET_CHART_QUERY_CONFIGS_ERROR',

  GET_DASHBOARD_QUERIES_REQUEST: 'CHART/GET_DASHBOARD_QUERIES_REQUEST',
  GET_DASHBOARD_QUERIES_SUCCESS: 'CHART/GET_DASHBOARD_QUERIES_SUCCESS',
  GET_DASHBOARD_QUERIES_ERROR: 'CHART/GET_DASHBOARD_QUERIES_ERROR',

  SET_SELECTED_CHART_DEVIATION_SUCCESS: 'CHART/SET_SELECTED_CHART_DEVIATION_SUCCESS',
  SET_SELECTED_GROUP: 'CHART/SET_SELECTED_GROUP',
  SET_SELECTED_SUBMENU: 'CHART/SET_SELECTED_SUBMENU',
  SET_SELECTED_GROUP_CHANNELS: 'CHART/SET_SELECTED_GROUP_CHANNELS',

  SET_GROUP_SOURCE_NAME_SWITCH: 'CHART/SET_GROUP_SOURCE_NAME_SWITCH',
  SET_GROUP_SOURCE_NAME_CHECKED_LIST: 'CHART/SET_GROUP_SOURCE_NAME_CHECKED_LIST',

  GET_DASHBOARD_TABLE_QUERIES_REQUEST: 'CHART/GET_DASHBOARD_TABLE_QUERIES_REQUEST',
  GET_DASHBOARD_TABLE_QUERIES_SUCCESS: 'CHART/GET_DASHBOARD_TABLE_QUERIES_SUCCESS',
  GET_DASHBOARD_TABLE_QUERIES_ERROR: 'CHART/GET_DASHBOARD_TABLE_QUERIES_ERROR',

  GET_HISTORICAL_STATUS_REQUEST: 'BATCH/GET_HISTORICAL_STATUS_REQUEST',
  GET_HISTORICAL_STATUS_SUCCESS: 'BATCH/GET_HISTORICAL_STATUS_SUCCESS',
  GET_HISTORICAL_STATUS_ERROR: 'BATCH/GET_HISTORICAL_STATUS_ERROR'
};
